export default __webpack_public_path__ + "static/media/empty-street.1921a28b.svg";